;
(function ($, root) {
  var api = require('./modules/xl_api');
  var stat = require('./modules/stat');
  var errorCatch = require('./modules/error_catch');
  var documentWrite = require('./modules/document_write');
  var Plugin = require('./modules/plugin');
  var Global = require('./modules/global');
  var Raven = require('./utils/raven');
  var ravenLoggerPlugin = require('@xunlei/raven-logger-plugin');
  var md5 = require('md5');
  var XL_CLIENT_VERION = 'XL_CLIENT_VERION';
  var WRAP_SIZE = $('#wrap').attr('class');

  require('./modules/prototype');
  require('./modules/polyfill');

  var whiteList = ['isfirstVisit', 'isSetMainPage', 'lastWordSuffix'];
  var staticCfgUsed = false;

  // 容错 防止调试时忘记删除 logger.debug 方法
  if (!root.console) {
    root.console = {};
    root.console.log = $.noop;
  }

  // 容错 非调试模式 xlog 对象的异常处理
  if (!root.xlog || !root.Xlog) {
    root.Xlog = root.xlog = {};
    root.Xlog.log = root.xlog.log = $.noop;
  }

  /**
   * 通用js,每个页面都会调用的代码
   * @class Common
   * @constructor
   */
  var Common = {
    /**
     * @property version
     * @type String
     */
    version: '1.0',

    // 百度计费名
    BAIDU_ID: '49029047_dg',

    SOGOU_ID: 'sogou-wsse-5317b6799188715d',

    // 第三方计费名
    // THIRD_ID: 'SE_hldp05820_t37ujxqs',

    // 全局定时器
    timer: {},

    /**
     * @property userAgent
     * @type String
     */
    userAgent: navigator.userAgent.toLowerCase(),

    /**
     * 事件库对象
     * @property events
     * @type Object
     */
    events: new EventEmitter(),

    /**
     * @property userId
     * @type String
     */
    userId: '',

    /**
     * @property jumpKey
     * @type String
     */
    jumpKey: '',

    // http://www.w3.org/TR/css3-selectors/#whitespace
    whitespace: '[\\x20\\t\\r\\n\\f]',

    timestamp: root.timestamp,

    env: root.env,

    /**
     * 嗅探关键词后缀
     * @property xiutanSuffix
     * @type String
     */
    xiutanSuffix: ' 迅雷下载',
    xiutanSuffixRatio: [{
      ratio: .3,
      value: '迅雷下载'
    }, {
      ratio: .1,
      value: 'thunder',
    }, {
      ratio: .1,
      value: 'FTP'
    }, {
      ratio: .1,
      value: 'MP4'
    }, {
      ratio: .1,
      value: '百度云'
    }, {
      ratio: .1,
      value: 'QQ旋风'
    }, {
      ratio: .1,
      value: 'BT'
    }, {
      ratio: .1,
      value: '快车'
    }],

    /**
     * 短视频接口地址
     * @property videoApi
     * @type string
     * @default http://interface.m.sjzhushou.com/
     */
    videoApi: 'http://interface.m.sjzhushou.com',

    /**
     * 模块初始化
     * @method init
     */
    init: function () {
      this.initUI();
      this.eventBinding();
    },

    /**
     * 界面初始化
     * @method initUI
     */
    initUI: function () {
      // Xbrowser IE核注册事件会有延迟
      var _delay = Common.isIE() ? 400 : 0;
      Common.getClientInfo();
      setTimeout(Common.resizeHandler, _delay);
    },

    /**
     * 事件绑定
     * @method eventBinding
     */
    eventBinding: function () {
      $(root).on('resize', Common.resizeHandler);
      $(root).on('resize', function () {
        var curSize = $('#wrap').attr('class');
        if (WRAP_SIZE === curSize) {
          return;
        }

        Common.events.trigger('WRAP_SIZE_CHANGE');
        WRAP_SIZE = curSize;
      });

      // 统一错误处理
      if (Common.env === 'production') {
        window.onerror = errorCatch;
      }

      // document.write设置域名白名单防止劫持
      documentWrite.config({
        whiteLists: [
          'img.jiuwo.kanimg.com',
          'act.vip.xunlei.com',
          'niu.xunlei.com',
          'v2.boxpage.niu.xunlei.com',
          'meitu.xunlei.com',
          'static.webgame.kanimg.com'
        ]
      });
    },

    isIE: function () {
      return /msie/.test(this.userAgent) || /trident/.test(this.userAgent);
    },

    isIE8: function () {
      return /msie 8.0/.test(this.userAgent);
    },

    /**
     * 是否大尺寸页面
     * @method isFullScreen
     */
    isBSWindow: function () {
      return $(window).height() >= 790 && $(window).width() >= 1080;
    },

    /**
     * 嗅探功能，关键词加入后缀' 迅雷下载',跳转至百度
     * @method xiutan
     * @param {string} val - 嗅探关键词
     */
    xiutanHandler: function (val) {
      var arr = [];
      var patt;
      var match;
      var url;
      var tn = Common.SOGOU_ID; // 计费名
      for (var i = 0, j = Common.xiutanSuffixRatio.length; i < j; i++) {
        arr.push(Common.xiutanSuffixRatio[i].value);
      }
      patt = new RegExp('^(\.+)' + Common.whitespace + '+(?:' + arr.join('|') + ')$');
      match = val.match(patt);
      if (match && match.length > 2) {
        val = match[1];
      }

      // url = 'http://www.baidu.com/s?&wd=' + encodeURIComponent(val) + '&tn=' + tn;
      url = 'http://www.sogou.com/sie?query=' + encodeURIComponent(val) + '&pid=' + tn;
      stat.trackEvent({
        key: 'right_area',
        attr1: 'start_search',
        extData: 'word=' + encodeURIComponent(val) +
          ',baiduchannel=' + tn
      });

      if (Global.isMacXunlei) {
        root.location.href = url;
      } else {
        root.open(url);
      }
    },

    /**
     * 窗口大小变化时的处理事件
     * @method resizeHandler
     */
    resizeHandler: root.resizeHandler || $.noop,

    /**
     * 重写窗口大小变化时的处理事件
     * @method overWriteResizeHandler
     */
    overWriteResizeHandler: function (handler) {
      Common.resizeHandler = handler;
    },

    /**
     * 从cookie中取值
     * @method getCookie
     */
    getCookie: function (name) {
      return decodeURIComponent((document.cookie.match(new RegExp("(^" + name + "| " + name + ")=([^;]*)")) == null) ? "" : RegExp.$2);
    },

    /**
     * 用户登出时清除cookie
     * @method clearCookie
     */
    clearCookie: function () {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--;) {
          if (_.indexOf(whiteList, keys[i]) != -1) {
            continue;
          }
          document.cookie = keys[i] + '=0;domain=xunlei.com;path=/;expires=' + new Date(0).toUTCString();
        }
      }
    },

    /**
     * 设置cookie值
     * @method setBenCookie
     */
    setBenCookie: function (name, value, sec) {
      if (arguments.length > 2) {
        var expireDate = new Date(new Date().getTime() + sec * 1000);
        document.cookie = name + "=" + escape(value) + "; path=/;domain=xunlei.com; expires=" + expireDate.toGMTString();
      } else {
        document.cookie = name + "=" + escape(value) + ";domain=xunlei.com; path=/;";
      }
    },

    setXl9Data: function (name, value, sec) {
      var xl9Data = JSON.parse(this.getCookie('xl9_data') || '{}');
      xl9Data[name] = value;
      this.setBenCookie('xl9_data', JSON.stringify(xl9Data), sec);
    },

    getXl9Data: function (name) {
      var xl9Data = JSON.parse(this.getCookie('xl9_data') || '{}');
      if (arguments.length == 1) {
        return xl9Data[name];
      } else {
        return xl9Data;
      }
    },

    /**
     * 获取地址栏参数
     * @method getParameter
     */
    getParameter: function (name) {
      var pattern = new RegExp("[?&]" + name + "\=([^&#]+)", "g");
      try {
        var matcher = pattern.exec(document.location.href);
      } catch (e) {}
      if (null != matcher) {
        return decodeURIComponent(matcher[1]);
      } else {
        return null;
      }
    },

    /**
     * 判断用户是否登录
     * @method isLogin
     */
    isLogin: function () {
      var sessionid = this.getCookie('sessionid');
      var userid = this.getCookie('userid');
      if (sessionid && userid && userid > 0) {
        return true;
      } else {
        return false;
      }
    },

    isVip: function () {
      return this.getCookie('isvip') == 1 ? true : false;
    },

    // 登录态不一致
    webLoginStatusMissing: function () {
      var clientUid = api.getUserID();
      var webUid = Common.getCookie('userid');
      var clientLogined = clientUid > 0;
      var webLogined = Common.isLogin();
      var isJumping = Common.getXl9Data('is_loging') === 1;
      // 客户端有登录态, 网页没有登录态, 不处于 jumpkey 中
      // 客户端有登录态, 网页有登录态, 两方userid不一致, 不处于 jumpkey 中
      return (clientLogined && !webLogined && !isJumping) || (clientLogined && webLogined && clientUid !== webUid && !isJumping);
    },

    // 客户端无登录态
    clientLogined: function () {
      var clientUid = api.getUserID();
      return clientUid > 0;
    },

    /**
     * 登陆态事件
     * @method loginStatusEmit
     */
    loginStatusEmit: function () {},

    /**
     * 通过异步请求刷新cookie重置登录态
     * @method userInfoReady
     */
    userInfoReady: function () {
      logger.debug('start checkWebLogin');
      if (Common.getXl9Data('is_loging') == 1) {
        Common.pollingForLoginStatus();
        logger.debug('is jumping');
        return;
      }

      var nativeUserID = api.getUserID();
      var commonUserID = Common.userId;
      var webUserID = Common.getCookie('userid');
      var webSessionid = Common.getCookie('sessionid');
      var jumpKey = api.getJumpKey();
      Common.setXl9Data('version', '5.13');
      Common.setXl9Data('versionCode', '10270');
      // 检查webuserID和nativeUserID
      logger.debug('nativeUserID: ' + nativeUserID);
      logger.debug('commonUserID: ' + commonUserID);
      logger.debug('webUserID: ' + webUserID);
      if (nativeUserID && nativeUserID !== webUserID || !webSessionid) {
        if (jumpKey) {
          Common.setXl9Data('is_loging', 1);
          logger.debug('set is_loging: ' + Common.getXl9Data('is_loging'));
          var jumpURL = 'http://in.xl9.xunlei.com/index.php/user/jumpkey?_=' + new Date().valueOf();
          var url = 'http://jump.xunlei.com/jump/?u1=' + encodeURIComponent(jumpURL) + '&jump_key=' + jumpKey;
          $.ajax({
            url: url,
            dataType: 'jsonp',
            jsonpCallback: 'callback',
            complete: function () {
              logger.debug('set is_loging: ' + Common.getXl9Data('is_loging'));
              Common.setXl9Data('is_loging', 0);
              Common.events.trigger('FINISH_JUMP');
            }
          });
        }
      }
    },

    // 轮循登录态，暂时没有更好的办法进行页面通信
    // jump 时其它页通过轮循来触发 FINISH_JUMP 事件
    pollingForLoginStatus: function () {
      // 判断方面是否监听Jump事件
      if (!Common.LISTEN_JUMP) {
        return;
      }

      var count = 0;
      var t = setInterval(function () {
        // 如果函数出错，会出现一执行的死循环，所以放在try catch 里面防止死循环
        try {
          if (count > 10) {
            clearInterval(t);
            return;
          }

          var webSessionid = Common.getCookie('sessionid');
          if (webSessionid) {
            Common.events.trigger('FINISH_JUMP');
            clearInterval(t);
          }
          count++;
        } catch (e) {
          clearInterval(t);
        }
      }, 1000);
    },

    /**
     * 浏览器tab页展现事件
     * @method pageShowBinding
     */
    pageShowBinding: function (callback) {
      $('body').on('click', 'a[href][href!="javascript:;"]', function (e) {
        var $target = $(e.target).closest('a');
        stat.trackEvent('browsertabpage_show', 'url_click');
        typeof callback == 'function' && callback($target);
      });
    },
    /**
     * @method getPubTime
     * @param time {number} 秒数
     * @return {string}
     */
    getPubTime: function (time) {
      var now = new Date().getTime();
      var t = now - time * 1000;
      var result = '';
      // 5分钟以内s
      if (t < 1000 * 60 * 5) {
        result = '刚刚';
        // 0<M<60 M分钟前
      } else if (t < 1000 * 60 * 60) {
        result = parseInt(t / (1000 * 60), 10) + '分钟前';
        // 3＞H≥1 1小时前
      } else if (t < 1000 * 60 * 60 * 3) {
        result = '1小时前';
        // 5＞H≥3 3小时前
      } else if (t < 1000 * 60 * 60 * 5) {
        result = '3小时前';
        // 7＞H≥5 5小时前
      } else if (t < 1000 * 60 * 60 * 7) {
        result = '5小时前';
        // 10＞H≥7 7小时前
      } else if (t < 1000 * 60 * 60 * 10) {
        result = '7小时前';
        // 14＞H≥10 10小时前
      } else if (t < 1000 * 60 * 60 * 14) {
        result = '10小时前';
        // 20＞H≥14 14小时前
      } else if (t < 1000 * 60 * 60 * 20) {
        result = '14小时前';
        // 30＞H≥20 20小时前
      } else if (t < 1000 * 60 * 60 * 30) {
        result = '20小时前';
        // 48＞H≥30 30小时前
      } else if (t < 1000 * 60 * 60 * 48) {
        result = '30小时前';
        // 72＞H≥48 48小时前
      } else if (t < 1000 * 60 * 60 * 72) {
        result = '48小时前';
        // 120＞H≥72 三天前
      } else if (t < 1000 * 60 * 60 * 120) {
        result = '三天前';
        // 168＞H≥120 五天前
      } else if (t < 1000 * 60 * 60 * 168) {
        result = '五天前';
        // H≥168 七天前
      } else {
        result = '七天前';
      }
      return result;
    },

    /**
     * @description cdn配置加载
     * @method loadConfig
     */
    loadConfig: function (callback) {
      var _t = new Date().format('YYYYMMDDhh'); // 为了减少cdn回源请求，改成每小时一个版本号
      var cfg_url = common.env === 'production' ? ('http://misc.xl9.xunlei.com/res/data/config.json?_t=' + _t) : ('http://admin.static.xl9.xunlei.com/json/config.json?_t=' + _t);
      var TEST = Common.getParameter('t');
      if (TEST) {
        cfg_url = 'http://admin.static.xl9.xunlei.com/test/json/test.json?_t=' + Date.now();
      }

      if (!staticCfgUsed && !TEST && root.__XL_CONFIG_FILE) {
        typeof callback == 'function' && callback(data);
        staticCfgUsed = true;
        return $.Deferred().resolve(root.__XL_CONFIG_FILE);
      } else {
        return $.ajax({
          url: cfg_url,
          dataType: 'jsonp',
          cache: true,
          jsonpCallback: 'xl_callback',
          timeout: 5000,
          success: function (data) {
            typeof callback == 'function' && callback(data);
          },
          error: function () {
            // alert('系统错误，请稍后重试');
          }
        });
      }
    },

    /**
     * @method logSearch
     * @description 上报搜索的资源
     * @param word
     */
    logSearch: function (word) {
      var data = {
        nickname: this.getCookie('usernick'),
        userid: this.getCookie('userid'),
        word: word
      };
      if (this.isVip() && data.nickname.length && data.userid.length && data.word.length) {
        $.ajax({
          url: 'http://in.xl9.xunlei.com/index.php/danmaku/log',
          dataType: 'jsonp',
          data: data
        });
      }
    },

    // 补0
    pad: function (num, n) {
      var len = num.toString().length;
      while (len < n) {
        num = "0" + num;
        len++;
      }
      return num;
    },

    htmlEncode: function (str) {
      var arr = [];
      if (str === null || str === '') {
        return str;
      }
      for (var i = 0, j = str.length; i < j; i++) {
        var c = str.charAt(i);
        switch (c) {
          case '&':
            arr.push('&amp;');
            break;
          case '<':
            arr.push('&lt;');
            break;
          case '>':
            arr.push('&gt;');
            break;
          case '"':
            arr.push('&quot;');
            break;
          case ' ':
            arr.push('&nbsp;');
            break;
          default:
            arr.push(c);
            break;
        }
      }
      return arr.join('');
    },

    // 获得浏览器相关信息
    getClientInfo: function () {
      if (Global.clientVersion) {
        return;
      }
      Global.clientVersion = api.getThunderVersion();

      if (Common.getCookie('XL_CLIENT_VERION') !== Global.clientVersion) {
        Common.setBenCookie(XL_CLIENT_VERION, Global.clientVersion, 365 * 24 * 3600);
      }

      if (Global.clientVersion !== 'unknow') {
        if (/^7./.test(Global.clientVersion)) {
          Global.isPcXunlei = true;
          Global.isPcXunlei7 = true;
        }
        if (/^9./.test(Global.clientVersion)) {
          Global.isPcXunlei = true;
          Global.isPcXunlei9 = true;
        }
        if (/^MacThunder/.test(Global.clientVersion)) {
          Global.isMacXunlei = true;
        }
        return;
      }
    },

    // 原生jsonp方法
    JSONP: function (opt) {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = opt.url + (opt.cache ? '' : '?_=' + new Date().valueOf());
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
      window[opt.jsonpCallback] = opt.success;
    },

    /**
     * 计算签名
     * @function sign
     * @param {Object} data - 签名参数
     * @param {string} secret - 密钥
     * @returns {string} 签名
     */
    sign: function (data, secret) {
      var arr = [];
      for (var key in data) {
        arr.push(key + '=' + data[key]);
      }
      return md5(arr.join('&') + secret);
    }
  };

  Raven.addPlugin(ravenLoggerPlugin);
  Common.logger = Raven.Logger;

  // 更新用户信息
  Common.events
    .on('FINISH_JUMP', function () {
      Raven.setUserContext({
        userid: Common.getCookie('userid')
      })
    })
    .on('userLogout', function () {
      Raven.setUserContext({})
    });
  var logger = Common.logger('common.js');
  // window.alert = function() {
  //     logger.error('Illegal alert', {
  //         error: new Error('Illegal alert'),
  //         args: arguments
  //     })
  // }
  // 页面入口
  $(function () {
    Common.init();
  });


  // 导出接口
  root.common = Common;
  root.definePlugin = Plugin.definePlugin;
  if (typeof exports === 'object') {
    module.exports = Common;
  }
})(jQuery, window);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/common.js
// module id = 1
// module chunks = 1 2 3 5 6 7 8 9 10 11 12